import React from 'react';
import '../App.css';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext.jsx';
import {  useState } from "react";
import axios from 'axios';
import { usePageConfig } from '../context/PageContext';

function AdminControlTab() {
    const { backendApiBaseUrl} = useConfig();
    const { pages } = usePageConfig();
    const { token } = useAuth();
    const [pendingChanges, setPendingChanges] = useState({});
    
    const handleChange = (pageKey, newValue) => {
        setPendingChanges(prev => ({
            ...prev,
            [pageKey]: newValue
        }));
    };

    const handleApply = async () => {
        const filteredChanges = Object.entries(pendingChanges).reduce(
            (acc, [pageKey, newValue]) => {
                if (pages[pageKey] !== newValue) {
                    acc[pageKey] = newValue;
                }
                return acc;
            },
            {}
        );

        if (!Object.keys(filteredChanges).length) {
            setPendingChanges({});
            return;
        }

        try {
            await axios.post(
                `${backendApiBaseUrl}/admin/update/pages`,
                { changes: filteredChanges },
                {
                    headers: {
                        Authorization: `Bearer ${token.token}`,
                    },
                }
            );

            setPendingChanges({});
        } catch (err) {
            console.error(err);
            alert("Failed to update page.");
        }
    };



    return (
        <div className="morphpagecontent">
            <div id="infiniteScrollContainer">
                <div className="container mt-5">
                    <div className="card p-4 shadow-sm border-0" style={{ backgroundColor: "#2b2d31", color: "#ffffff" }}>
                        <h1 className="text-center mb-4 border-bottom">Control Panel</h1>

                        {Object.entries(pages).map(([pageKey, enabled]) => {
                            const effectiveValue =
                                pendingChanges.hasOwnProperty(pageKey)
                                    ? pendingChanges[pageKey]
                                    : enabled;
                            return (
                                <div key={pageKey} className="d-flex justify-content-between align-items-center mb-3">
                                    <span>{pageKey}</span>

                                    <select
                                        className="form-select w-auto"
                                        value={effectiveValue ? "enabled" : "disabled"}
                                        onChange={e =>
                                            handleChange(pageKey, e.target.value === "enabled")
                                        }
                                        style={{ color: 'black' }}
                                    >
                                        <option value="enabled" style={{ color: "black"}}>Enabled</option>
                                        <option value="disabled" style={{ color: "black"}}>Disabled</option>
                                    </select>
                                    
                                </div>
                                
                            );

                        })}
                        <div className="d-flex justify-content-end align-items-center mt-3">
                            <button className="btn btn-outline-secondary me-2" onClick={() => setPendingChanges({})}>Clear</button>
                            <button className='btn btn-outline-success' onClick={() => handleApply()} disabled={!Object.keys(pendingChanges).length}>Apply</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminControlTab;